import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { Typography, Paper } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { useStyles } from './style';

interface EmptyTableProps {
	label?: string;
}

const EmptyTable = (props: EmptyTableProps) => {
	const { label } = props;
	const { t } = useTranslation();

	const classes = useStyles();

	return (
		<Paper className={classes.tipCard}>
			<InfoOutlinedIcon className={classes.icon} fontSize='small' />
			<Typography className={classes.tip}>{t(label)}</Typography>
		</Paper>
	);
};

export default EmptyTable;
